import moment from 'moment';

function prepareDigitForDate(digit) {
    return digit < 10 ? `0${digit}` : `${digit}`;
}

export function getDate(date, format) {
    switch (format) {
        case 'Y-m-d':
            return `${date.getFullYear()}-${
                prepareDigitForDate(date.getMonth() + 1)}-${
                prepareDigitForDate(date.getDate())}`;
        case 'H:i:s':
            return `${prepareDigitForDate(date.getHours())}:${
                prepareDigitForDate(date.getMinutes())}:${
                prepareDigitForDate(date.getSeconds())}`;
        case 'Y-m-d H:i:s':
            return `${helper.getDate(date, 'Y-m-d')} ${helper.getDate(date, 'H:i:s')}`;
        case 'U':
            // возвращает unix_time_stamp без микросекунд
            return Math.floor(date.getTime() / 1000);
        case 'Ymd_U':
            // возвращает unix_time_stamp без часов/минут/секунд
            return Date.parse(helper.getDate(date, 'Y-m-d')) / 1000;
        default:
            return '';
    }
}

export const converteAddTimezone = (date, offset, format = 'DD-MM-YYYY HH:mm:ss') => {
    return moment(date).add(offset, 'hours').format(format);
};

export const converteSubTimezone = (date, offset, format = 'DD-MM-YYYY HH:mm:ss') => {
    return moment(date).subtract(offset, 'hours').format(format);
};
